import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorised',
    templateUrl: './unauthorised.component.html',
    styleUrl: './unauthorised.component.scss',
    standalone: false
})
export class UnauthorisedComponent {}
